/**
 * Shim for @clariness/labeled-checkbox: re-exports with optional pointer/crossOrigin props
 * so React 19 types don't require them (theme-ui Pick<> types treat them as required).
 */
import React from 'react';
import {
  LabeledCheckbox as OrigLabeledCheckbox,
  type LabeledCheckboxProps,
} from '~clariness-labeled-checkbox';

type OptionalProps = {
  placeholder?: string;
  onPointerEnterCapture?: React.PointerEventHandler;
  onPointerLeaveCapture?: React.PointerEventHandler;
  crossOrigin?: string;
};

export type { LabeledCheckboxProps };
export const LabeledCheckbox =
  OrigLabeledCheckbox as React.ForwardRefExoticComponent<
    Omit<
      React.ComponentProps<typeof OrigLabeledCheckbox>,
      keyof OptionalProps
    > &
      OptionalProps &
      React.RefAttributes<HTMLInputElement>
  >;
